import { SolutionLanding } from "./SolutionLanding";

export default function HrInvestigations() {
  return (
    <SolutionLanding
      meta={{
        testid: "hr-landing-page",
        title: "WhatsApp Chat Conversion for HR Investigations | AuditPDF",
        description:
          "Convert WhatsApp exports into professional, audit-compliant chat logs for internal HR reviews and employee grievances. Zero-retention, GDPR compliant.",
        path: "/hr-workplace-investigations",
      }}
      hero={{
        eyebrow: "For HR & Employee Relations Teams",
        headline: "Audit-Compliant WhatsApp Records in Seconds.",
        sub: "Instantly transform raw employee chat exports into secure, review-ready PDFs. Built from the ground up for strict GDPR compliance and zero data retention.",
      }}
      pain={{
        title: "Screenshots don't close investigations. They invite tribunals to question them.",
        points: [
          {
            title: "Screenshot Sprawl",
            body: "Dozens of cropped images lack timestamps, context, and the chronological integrity required for a formal grievance review.",
          },
          {
            title: "Manual Transcription Errors",
            body: "Copy-pasting messages into Word documents burns hours and introduces formatting errors that an employee or union rep can dispute.",
          },
          {
            title: "GDPR & Privacy Risks",
            body: "Forwarding raw, unredacted text exports across internal inboxes exposes sensitive employee data beyond the authorized investigative team.",
          },
        ],
      }}
      solution={{
        title: "A secure, impartial record for grievance and disciplinary panels.",
        body: "AuditPDF acts as a deterministic processing engine, converting unstructured communication data into a perfectly chronological, universally readable document. The isolated architecture guarantees complete data privacy and removes the risk of human error.",
        bullets: [
          "Automated Chronology: Perfectly reconstructs exact timelines for conduct investigations without manual editing.",
          "Participant Verification: An automated Schedule of Participants clearly distinguishes saved contacts from unverified numbers.",
          "Isolated Media Processing: Voice notes and images are rendered within encrypted infrastructure—never exposed to third-party APIs.",
          "GDPR-Compliant Zero-Retention: Source files and generated PDFs are automatically purged. Confidential by design.",
        ],
        caseLabel: "INTERNAL REVIEW",
      }}
      showAffidavit={false}
      workflowSteps={[
        {
          title: "Upload",
          body: "Submit the WhatsApp export exactly as the employee or manager provided it. No editing or pre-processing required.",
        },
        {
          title: "Process",
          body: "Our isolated engine parses every message deterministically, fingerprinting the source file and formatting the transcript without AI inference.",
        },
        {
          title: "Download & Purge",
          body: "Receive a secure, one-hour expiring link to the complete PDF bundle. All source data is immediately purged to ensure strict data sovereignty.",
        },
      ]}
      finalCta={{
        headline: "Close the case file with documentation that stands up to review.",
        sub: "Stop risking GDPR breaches with manual formatting. Secure your Employee Relations data today.",
      }}
      crossLink={{ to: "/legal-court-bundles", label: "For Legal Teams" }}
    />
  );
}